// 'use strict';
import findNearestHeading from '../util/findNearestHeading.js';
import URL from 'url-parse';
/**
 * Universal Analytics pre-setup
 */
window.ga =
  window.ga ||
  function() {
    (ga.q = ga.q || []).push(arguments);
  };
const ga = window.ga;
ga.l = +new Date();

/*
 {Array} of tracker names
*/
const trackers = [];

/**
 * Tracks a JavaScript error with optional fields object overrides.
 * This function is exported so it can be used in other parts of the codebase.
 * E.g.:
 *
 *    `fetch('/api.json').catch(trackError);`
 *
 * @param {(Error|Object)=} err
 * @param {Object=} fieldsObj
 */
export const trackError = (err = {}, fieldsObj = {}) => {
  sendEvent(Object.assign({
    eventCategory : 'Error',
    eventAction   : err.name || '(no error name)',
    eventLabel    : `${err.message}\n${err.stack || '(no stack trace)'}`,
    nonInteraction: true,
  }, fieldsObj));
};


/**
 * Tracks any errors that may have occured on the page prior to analytics being
 * initialized, then adds an event handler to track future errors.
 */
const trackErrors = () => {
  // Errors that have occurred prior to this script running are stored on
  // `window.__e.q`, as specified in `index.html`.
  const loadErrorEvents = window.__e && window.__e.q || [];

  const trackErrorEvent = (event) => {
    // Use a different eventCategory for uncaught errors.
    const fieldsObj = {eventCategory: 'Uncaught Error'};

    // Some browsers don't have an error property, so we fake it.
    const err = event.error || {message: `${event.message} (${event.lineno}:${event.colno})`};

    trackError(err, fieldsObj);
  };

  // Replay any stored load error events.
  for (let event of loadErrorEvents) {
    trackErrorEvent(event);
  }

  // Add a new listener to track event immediately.
  window.addEventListener('error', trackErrorEvent);
};

const getDomain = (href) => {
  return new URL(href).hostname;
};

/*
 * Coalesce all text or img[alt] text inside the clicked link
 */
const getLinkText = (el) => {
  const $el = $(el);
  if ($el.text().length) {
    return 'linkText:' + $el.text().replace(/\s+/g, ' ');
  } else {
    //check to see if there is an image
    const $img = $el.find('img');
    if ($img.length) {
      //check to see if there is an image with an alt tag
      if ($img.attr('alt')) {
        let altText = $img.attr('alt');
        // if altText only has whitespaces, indicate it, otherwise return the text
        if (!altText.replace(/\s/g, '').length) {
          return 'altTagText:<whiteSpace>';
        } else {
          return 'altTagText:' + altText;
        }
      } else {
        return 'ImageHasNoAltTag';
      }
    }
    // if no image, then indicate linkText is DoesNotExist
    return 'linkText:DoesNotExist';

  }
};

function getNearestParentDivID(el) {
  return $(el).closest('[id]')
    .attr('id') || 'DoesNotExist';
}

// this function sends custom data to eventCategory, eventAction, and eventLabel
// invoked from the below $("a").on('click', function ...
function sendEvent(category, action, label) {
  for (let i = trackers.length - 1; i >= 0; i--) {
    if (typeof category === 'object') {
      return ga(trackers[i] + '.send', 'event', category);
    }
    ga(trackers[i] + '.send', 'event', {
      'eventCategory': category,
      'eventAction'  : action,
      'eventLabel'   : label,
    });
  }
}

const getContext = ($el) => {
  let context = '';

/*
  if ($el.parents('#main-content').length) {
    context += findNearestHeading($el);
    console.log('context-nearestHeading: '+context);
  }
  if (context !== '') {
    context = '__context:' + context;
        console.log('context-normal: '+context);
  }
  */
   
  // check if link stays on subdomain or not, and indicate if so
  if (getDomain($el.attr('href')) !== $(window.location).attr('hostname')) {
    context += '__outgoing-link';
  }
  
  return context;
};

const sections = {
  'global-dropdown'               : '#uark-quick-links-items,#uark-mobile-menu',
  'global-footer-links'           : '#uark-footer-global-links',
  'global-footer-social'          : '#social-stack',
  'global-footer-buttons'         : '.footer-buttons',
  'global-footer-disclaimer-links': '.footer-disclaimer',
  'topnav'                        : '#uark-site-topnav',
  'sidenav'                       : '#uark-sidebar',
  'section-footer'                : 'section#section-footer',
};

const attachEventListenters = () => {

  // track searches
  $('#uark-search').closest('form')
    .on('submit', function() {
      sendEvent(
        'headerSearch',
        $('#uark-search').val(),
        'pageLocation:' + window.location,
      );
    });

  // for any click on any anchor element, track an event
  $('body').on('click', function(evt) {
    if (!$(evt.target).is('a')) {
      return; // bail out, this wasn't a link
    }

    const $this = $(evt.target);

    const textValue = getLinkText($this);
    const context = getContext($this);


    for (const section in sections) {
      const parentSelector = sections[section];
      if ($this.parents(parentSelector).length) {
        sendEvent(
          $this.attr('href'),
          'section:' + section +
          '__' + textValue +
          '__' + 'pageLocation:' + window.location +
          context,
          textValue
        );
        return;
      }
    }

    if ($this.parents('#main-container').length) {
      sendEvent(
        $this.attr('href'),
        'section:main-container' +
        '__closestParentID:' + getNearestParentDivID($this) +
        '__' + textValue +
        '__' + 'pageLocation:' + window.location +
        context,
        textValue
      );
      return;
    }

    sendEvent(
      $this.attr('href'),
      'section:body' +
        '__' + 'closestParentID:' + getNearestParentDivID($this) +
        '__' + textValue +
        '__' + 'pageLocation:' + window.location +
        context,
      textValue
    );
  });
};

const addTracker = (propertyId) => {
  const trackerName = propertyId.replace(/[^\d\w]+/g, '');
  trackers.push(trackerName);

  ga('create', propertyId, 'auto', {'name': trackerName});

  ga(trackerName + '.require', 'linkid');
  ga(trackerName + '.set', 'transport', 'beacon');
  ga(trackerName + '.send', 'pageview');
};

export const init = (propertyIDs = []) => {
  for (let i = propertyIDs.length - 1; i >= 0; i--) {
    addTracker(propertyIDs[i]);
  }
  trackErrors();
  // attach event listeners after the page is loaded.
  $(attachEventListenters());
  return {
    'sendEvent'     : sendEvent,
    'addTracker'    : addTracker,
    'trackError'    : trackError,
    'listProperties': () => trackers,
    'getContext'    : getContext,
  };
};


